export default "__VITE_ASSET__zZ0ioYYF__"